import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  TextInput,
  Form,
  ButtonSet,
  Button,
  SelectItem,
  Select,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";
import { useForm } from "react-hook-form";
import http from "../../http-common";
import {
  traineeProfileSchema,
  vacancySchema,
} from "../../services/SchemaService";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import { AuthContext } from "../../contexts/AuthContext";
import useTraineeProfile from "../../hooks/useTraineeProfile";
import useGet from "../../hooks/useGet";
import GenericCombo from "../../components/Combos/GenericCombo";
import useAuth from "../../hooks/useAuth";
import Card from "../../components/Card/Card";
import { Toggle } from "carbon-components-react";
import { Checkbox } from "carbon-components-react";

const TraineeProfileSummaryPage = () => {
  const { user, isWinner, isInternshipJury } = useAuth();
  const params = useParams();
  const [id] = useState(params.id);
  const [disabled, setDisabled] = useState(true);
  const [application, setApplication] = useState({});
  const [isEligible, setIsEligible] = useState(false);
  const navigate = useNavigate();
  const { data: provinces } = useGet("/utils/provinces");
  const [districts, setDistricts] = useState([]);

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(traineeProfileSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
    } catch (error) {}
  };

  const handleApplicationEligibility = async (e) => {
    try {
      const response = await http.put(
        `/internships/application/${id}/eligibility/${e}`,
        {}
      );
      setIsEligible(e);
      toast.success("Elegibilidade actualizada com sucesso");
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    const getProfile = async () => {
      try {
        const result = await http.get(`/internships/application/${id}`);
        if (result.data?.trainee.provinceId) {
          try {
            const response = await http.get(
              "/utils/provinces/" +
                result.data?.trainee.provinceId +
                "/districts"
            );
            setDistricts(response.data);
          } catch (error) {
            toast.error(error?.response?.data.message);
          }
        }

        reset(result.data?.trainee);
        setApplication(result.data);
      } catch (error) {
        toast.error(error.response?.data.message);
      }
    };

    getProfile();
  }, [id]);

  useEffect(() => {
    setIsEligible(application?.isEligible);
  }, [application]);

  // useEffect(() => {}, [isEligible]);

  return (
    <Card title="Candidato a estágio">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup legendText="SECÇÃO B" className="section-header">
          <Row>
            <Column xml={12} sm={6} md={3} lg={3} className="required">
              <Select
                id="provinceId"
                labelText="Província"
                disabled={disabled}
                {...register("provinceId")}
              >
                <SelectItem text="" value="" />
                {provinces.map((p) => (
                  <SelectItem text={p.description} value={p.id} key={p.id} />
                ))}
              </Select>
              <p className="field-error">{errors.provinceId?.message}</p>
            </Column>

            <Column xml={12} sm={6} md={3} lg={3} className="required">
              <Select
                id="districtId"
                name="districtId"
                labelText="Cidade/Distrito"
                disabled={disabled}
                // value={application?.districtId || ""}
                {...register("districtId")}
              >
                <SelectItem text="" value="" />
                {districts.map((p) => (
                  <SelectItem text={p.description} value={p.id} key={p.id} />
                ))}
              </Select>
              <p className="field-error">{errors.districtId?.message}</p>
            </Column>
            <Column xml={12} sm={6} md={6} lg={6}>
              <TextInput
                id="locality"
                labelText="Localidade"
                name="locality"
                maxLength={128}
                disabled={disabled}
                {...register("locality")}
              />
            </Column>
          </Row>

          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="education"
                labelText="B.1: Educação"
                helperText="[Descreva a sua formação académica, escreva os níveis que concluiu e as respectivas datas de conclusão e instituição de ensino]"
                rows={5}
                enableCounter
                disabled={disabled}
                {...register("education")}
              />
              <p className="field-error">{errors.education?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="courses"
                labelText="B.2: Cursos adicionais/complementares/certificados"
                helperText="[Descreva os cursos adicionais e capacitações que tenha realizado, as instituições e respectivas datas; Inclua também aqui os Softwares que domina]"
                rows={5}
                enableCounter
                disabled={disabled}
                {...register("courses")}
              />
              <p className="field-error">{errors.courses?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="experience"
                labelText="B.3: Experiência Profissional "
                helperText="[Descreva os empregos ou experiências profissionais prévias que teve, listando: a empresas, a duração, as principais actividades que realizou]"
                rows={5}
                enableCounter
                disabled={disabled}
                {...register("experience")}
              />
              <p className="field-error">{errors.experience?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="languages"
                labelText="B.4: Idiomas"
                helperText="[Liste as línguas nas quais pode trabalhar (falar, ler, escrever)]"
                rows={5}
                enableCounter
                disabled={disabled}
                {...register("languages")}
              />
              <p className="field-error">{errors.languages?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="skills"
                labelText="B.5: Habilidades comportamentais/atitudes"
                helperText="[Liste os principais comportamentos, atitudes e habilidades sociais que possui que são relevantes para o ambiente profissional ]"
                rows={5}
                enableCounter
                disabled={disabled}
                {...register("skills")}
              />
              <p className="field-error">{errors.skills?.message}</p>
            </Column>
          </Row>
          {isInternshipJury && (
            <Row>
              <Column sm={2} md={4} lg={4}>
                <FormGroup legendText="">
                  <RadioButtonGroup
                    legendText="Elegível"
                    name="isElegible"
                    className="required"
                    valueSelected={String(application?.isEligible)}
                    onChange={handleApplicationEligibility}
                  >
                    <RadioButton id="elegible-y" labelText="Sim" value="true" />
                    <RadioButton
                      id="elegible-n"
                      labelText="Não"
                      value="false"
                    />
                  </RadioButtonGroup>
                </FormGroup>
              </Column>
            </Row>
          )}
        </FormGroup>

        <Row>
          <Column sm={12} md={12} lg={12} className="form-buttons">
            <ButtonSet>
              {isInternshipJury && isEligible && (
                <SubmitButton
                  label="Pontuar"
                  onClick={() => navigate(`../pontuar-estagiario/${id}`)}
                />
              )}
              <CancelButton />
            </ButtonSet>
          </Column>
        </Row>
      </Form>
    </Card>
  );
};

export default TraineeProfileSummaryPage;
